import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-194e79de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin-bottom":"15px","text-align":"left"} }, "營業日總表", -1))
const _hoisted_2 = { style: {"margin-bottom":"10px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 下載營業日總表 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin-bottom":"15px","text-align":"left"} }, "拆帳明細表", -1))
const _hoisted_5 = { style: {"margin-bottom":"10px"} }
const _hoisted_6 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("包含未繳費")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 下載拆帳明細表 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin-bottom":"15px","text-align":"left"} }, "獲利總表", -1))
const _hoisted_10 = { style: {"margin-bottom":"10px"} }
const _hoisted_11 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("包含未繳費")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 下載獲利彙總表 ")

import { ref, onMounted } from "vue";
import API from '@/apis/TPSAPI';
import { M_ICloseAccountRecord } from "@/models/M_ICloseAccount";
import { M_ITeachersOptions } from "@/models/M_ITeachersOptions";
import { ElMessage } from 'element-plus';

// PDF Report controls

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportMgmt',
  setup(__props) {

const selectedDate = ref<string>('');
const salaryDateRange = ref<string[]>([]);
const salaryTeacherId = ref<number | null>(null);
const salaryIncludePaid = ref<boolean>(true);
const profitDateRange = ref<string[]>([]);
const profitTeacherId = ref<number | null>(null);
const profitIncludePaid = ref<boolean>(true);
const teacherList = ref<M_ITeachersOptions[]>([]);

// Close account records
const dateRange = ref<string[]>([]);
const closeAccountRecords = ref<M_ICloseAccountRecord[]>([]);

const formatDate = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const handleDateRangeChange = async (dates: string[] | null) => {
  if (!dates || dates.length !== 2) {
    closeAccountRecords.value = [];
    return;
  }

  const [startDate, endDate] = dates;

  try {
    const response = await API.getCloseAccounts(startDate, endDate);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    closeAccountRecords.value = response.data.content;

    ElMessage.success(`查詢成功，找到 ${closeAccountRecords.value.length} 筆關帳記錄`);

    console.log('關帳記錄:', closeAccountRecords.value);

  } catch (error) {
    closeAccountRecords.value = [];
    ElMessage.error((error as Error).message || '查詢關帳記錄失敗');
  }
};

// Download PDF helper function
const downloadPDF = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// 下載營業日總表
const downloadDailyReport = async () => {
  if (!selectedDate.value) {
    ElMessage.warning('請選擇日期');
    return;
  }

  try {
    const response = await API.getDailyReportPDF(selectedDate.value);
    downloadPDF(response.data, `營業日總表_${selectedDate.value}.pdf`);
    ElMessage.success('PDF 下載成功');
  } catch (error) {
    ElMessage.error((error as Error).message || '下載失敗');
  }
};

// 下載拆帳明細表
const downloadSalaryReport = async () => {
  if (!salaryDateRange.value || salaryDateRange.value.length !== 2) {
    ElMessage.warning('請選擇日期範圍');
    return;
  }
  if (!salaryTeacherId.value) {
    ElMessage.warning('請選擇老師');
    return;
  }

  try {
    const [startDate, endDate] = salaryDateRange.value;
    const response = await API.getSalaryReportPDF(
      startDate,
      endDate,
      salaryTeacherId.value,
      salaryIncludePaid.value
    );
    downloadPDF(response.data, `拆帳明細表_${startDate}_${endDate}.pdf`);
    ElMessage.success('PDF 下載成功');
  } catch (error) {
    ElMessage.error((error as Error).message || '下載失敗');
  }
};

// 下載獲利彙總表
const downloadProfitReport = async () => {
  if (!profitDateRange.value || profitDateRange.value.length !== 2) {
    ElMessage.warning('請選擇日期範圍');
    return;
  }
  if (!profitTeacherId.value) {
    ElMessage.warning('請選擇老師');
    return;
  }

  try {
    const [startDate, endDate] = profitDateRange.value;
    const response = await API.getCompanyProfitSummaryPDF(
      startDate,
      endDate,
      profitTeacherId.value,
      profitIncludePaid.value
    );
    downloadPDF(response.data, `獲利彙總表_${startDate}_${endDate}.pdf`);
    ElMessage.success('PDF 下載成功');
  } catch (error) {
    ElMessage.error((error as Error).message || '下載失敗');
  }
};

// Load teacher list on mount
onMounted(async () => {
  try {
    const response = await API.getTeachersOptions();
    if (response.data.result === 1) {
      teacherList.value = response.data.content;
    }
  } catch (error) {
    console.error('載入教師列表失敗:', error);
  }
});


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_row, {
      gutter: 20,
      style: {"margin-bottom":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_date_picker, {
                modelValue: selectedDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                type: "date",
                placeholder: "選擇日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadDailyReport,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider, { style: {"margin":"30px 0"} }),
    _hoisted_4,
    _createVNode(_component_el_row, {
      gutter: 20,
      style: {"margin-bottom":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 9 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_date_picker, {
                modelValue: salaryDateRange.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((salaryDateRange).value = $event)),
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "開始日期",
                "end-placeholder": "結束日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: salaryTeacherId.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((salaryTeacherId).value = $event)),
                placeholder: "選擇老師",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherList.value, (teacher) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: teacher.teacherId,
                      label: teacher.teacherName,
                      value: teacher.teacherId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: salaryIncludePaid.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((salaryIncludePaid).value = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "success",
                onClick: downloadSalaryReport
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider, { style: {"margin":"30px 0"} }),
    _hoisted_9,
    _createVNode(_component_el_row, {
      gutter: 20,
      style: {"margin-bottom":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 9 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_date_picker, {
                modelValue: profitDateRange.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((profitDateRange).value = $event)),
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "開始日期",
                "end-placeholder": "結束日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_select, {
                modelValue: profitTeacherId.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((profitTeacherId).value = $event)),
                placeholder: "選擇老師",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherList.value, (teacher) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: teacher.teacherId,
                      label: teacher.teacherName,
                      value: teacher.teacherId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: profitIncludePaid.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((profitIncludePaid).value = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "warning",
                onClick: downloadProfitReport
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider, { style: {"margin":"30px 0"} })
  ], 64))
}
}

})